import Vue from 'vue'

export async function getMensajes(context, [access_token]) {
    try {
        if (access_token) {
            context.commit('setLoading', true, { root: true })
            const response = await Vue.axios({
                method: 'GET',
                url: '/mensajes',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })
            context.commit('mensajes/setMensajes', response.data.data, { root: true })
        }

    } catch (e) {
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}




export async function crearMensaje(context, [access_token, modelMensaje]) {
    try {

        if (access_token) {
           // context.commit('setLoading', true, { root: true })
            const response = await Vue.axios({
                method: 'POST',
                url: '/mensajes',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: modelMensaje
            })
          
           // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
     //  context.commit('setLoading', false, { root: true })
    }
}

export async function updateMensaje(context, [access_token, modelMensaje]) {
    try {
        if (access_token) {
          
            const response = await Vue.axios({
                method: 'PUT',
                url: '/mensajes/' + modelMensaje.id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: modelMensaje

            })
            if (response.status == 200) {
                context.commit('mensajes/actListMensajes', response.data.data, { root: true })
               }
           return response;
           // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
     // context.commit('setLoading', false, { root: true })
    }
}

export async function eliminarMensaje(context, [access_token, mensaje_id]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'DELETE',
                url: '/mensajes/' + mensaje_id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })

         
           if (response.status == 200) {
            context.commit('mensajes/actDeleteListMensajes', mensaje_id, { root: true })
           }
           return response;
          
           // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
      // context.commit('setLoading', false, { root: true })
    }
}





